import { useCountryCode } from '../pricing/useCurrencyDetails';
export const useRussianBlockedBanner = () => {
  const countryCode = useCountryCode();
  const shouldShowRussianBlockedBanner = countryCode === 'RU';
  return shouldShowRussianBlockedBanner;
};